import { RestApiSenderConfig } from 'ihub/common';
import { AdvancedTourStep } from '../../shared-types';
import { RestApiSenderTourProps } from './rest-api-sender-tour-props';

export function getRestApiSenderHeaderSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<RestApiSenderTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as RestApiSenderConfig;

	// TODO: optimize this to work when there are key values added, currently it only updates the object in the dictionary should a value be provided
	return [
		{
			id: 'headers-add-key-value',
			selector: '[data-tour="headers-add-key-value"]',
			content: 'Add an additional header property to the request.',
		},
		...(config.additionalHeaders
			? [
					{
						id: 'headers-dictionary-item-key',
						selector: '[data-tour="headers-dictionary-item-key"]',
						content: 'The key value to assign to the new header',
					},
					{
						id: 'headers-dictionary-item-value',
						selector: '[data-tour="headers-dictionary-item-value"]',
						content: 'The value that will be assigned to the header.',
					},
					{
						id: 'headers-delete-dictionary-item',
						selector: '[data-tour="headers-dictionary-item-delete"]',
						content: 'Removes the header row and all of its config',
					},
				]
			: []),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
